import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  UseCompanyReturnType,
  useCompanyInternalHook,
} from 'hooks/useCompany/useCompanyInternal';
import { TCompany } from 'lib/models/company';
import { TOpportunity } from 'lib/models/opportunity';

const initialContext: UseCompanyReturnType = {
  company: {} as TCompany,
  similarCompanies: [],
  publishedJobs: [],
  publishedJobsTotalCount: 0,
  publishedInternshipsTotalCount: 0,
  isFollowLoading: false,
  socialMediaLinks: [],
  showBanner: false,
  updateUserAction: noop,
};

const CompanyContext = createContext<UseCompanyReturnType>(initialContext);

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider: React.FC<{
  company: TCompany;
  publishedJobs: Array<TOpportunity>;
  publishedJobsTotalCount: number;
  publishedInternshipsTotalCount: number;
}> = ({
  children,
  company,
  publishedJobs,
  publishedJobsTotalCount,
  publishedInternshipsTotalCount,
}) => {
  const value = useCompanyInternalHook({
    company,
    publishedJobs,
    publishedJobsTotalCount,
    publishedInternshipsTotalCount,
  });

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};
